import React from 'react';
import { Box, Chip } from '@mui/material';

/**
 * 筛选标签组件
 * @param {Array} options - 选项数组 [{label, value}]
 * @param {string|number} selectedValue - 选中值
 * @param {function} onChange - 变化回调
 */
export default function FilterChips({ options, selectedValue, onChange }) {
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {options.map((option) => (
        <Chip
          key={option.value}
          label={option.label}
          onClick={() => onChange(option.value)}
          color={selectedValue === option.value ? 'primary' : 'default'}
          variant={selectedValue === option.value ? 'filled' : 'outlined'}
          sx={{
            fontWeight: 600,
            borderRadius: 1,
            px: 1,
          }}
        />
      ))}
    </Box>
  );
}
